import { jsx as n, jsxs as o } from "../../_virtual/jsx-runtime.mjs";
import * as t from "react";
import i from "../../depend/classnames/index.mjs";
import { textArea as B, focused as F, inputError as H, inputWarning as P, inputSuccess as E, inputDisabled as I, textAreaWrap as $, textAreaDataCount as k, isOverMax as D, labelForInput as O, content as V, textAreaRequired as j, bottomInfo as q, info as W } from "./css/ReoTextArea.mjs";
import { suffixPx as K } from "../../utils/suffixPx.mjs";
import { getValByDef as X } from "../../utils/getValByDef.mjs";
import { omitTextAreaPropsKeys as z, defaultTextAreaProps as G } from "./const.mjs";
import J from "./Info.mjs";
import { useOmitProps as Q } from "../../hook/useOmitProps.mjs";
import { useCurrentStatus as U } from "../../hook/useCurrentStatus.mjs";
import { useTheme as Y } from "../../hook/useTheme.mjs";
import { EThemeTemplate as Z } from "../../common/type.mjs";
const v = t.forwardRef((e, C) => {
  const b = Y({ theme: e.theme, template: Z.TEXTAREA }), A = Q(
    e,
    z
  ), [r, s] = t.useState(""), a = t.useMemo(() => e.value ?? r, [e.value, r]), h = t.useMemo(
    () => X(e.lineHeight, G.lineHeight),
    [e.lineHeight]
  ), M = t.useMemo(
    () => e.overMaxLength ? void 0 : e.maxLength,
    [e.maxLength, e.overMaxLength]
  ), d = t.useMemo(
    () => !!(e.overMaxLength && a.length > (e.maxLength ?? 0)),
    [e.maxLength, e.overMaxLength, a.length]
  ), [x, f] = t.useState(!1), g = t.useRef(null);
  t.useImperativeHandle(C, () => g.current, []);
  const m = U(e), N = t.useMemo(() => i(
    B,
    e.textAreaClassName,
    x ? F : null,
    m === "error" ? H : null,
    m === "warning" ? P : null,
    m === "success" ? E : null,
    e.disabled ? I : null,
    $,
    "reo-basic-text-area",
    e.className
  ), [m, x, e.className, e.disabled, e.textAreaClassName]), L = t.useMemo(() => ({
    lineHeight: K(h),
    ...e.textAreaStyle,
    "--placeholder-color": e.placeholderColor,
    "--color": e.color,
    "--border-color": e.borderColor,
    "--active-color": e.activeBorderColor
  }), [
    h,
    e.activeBorderColor,
    e.borderColor,
    e.color,
    e.placeholderColor,
    e.textAreaStyle
  ]), T = t.useCallback((c) => {
    var u;
    const l = c.target.value;
    (u = e.onChange) == null || u.call(e, l), s(l);
  }, [e]), y = t.useCallback((c) => {
    var l;
    (l = e.onFocus) == null || l.call(e, c), f(!0);
  }, [e]), S = t.useCallback((c) => {
    var l, u;
    e.trim !== !1 && ((l = e.onChange) == null || l.call(e, a.trim()), s(a.trim())), (u = e.onBlur) == null || u.call(e, c), f(!1);
  }, [a, e]), R = t.useMemo(() => e.showCount ? /* @__PURE__ */ n(
    "span",
    {
      className: i(
        k,
        d ? D : null
      ),
      children: `${a.length}${e.maxLength ? `/${e.maxLength}` : ""}`
    }
  ) : null, [a.length, d, e.maxLength, e.showCount]), w = t.useMemo(() => e.label ? /* @__PURE__ */ n(
    "div",
    {
      className: O,
      children: /* @__PURE__ */ n(
        "label",
        {
          htmlFor: e.id,
          children: e.label
        }
      )
    }
  ) : null, [e.id, e.label]);
  return /* @__PURE__ */ o("div", { className: i(b, V, e.style, "reo-basic-text-area-content"), children: [
    w,
    /* @__PURE__ */ o("div", { className: "reo-basic-text-area-warp", children: [
      /* @__PURE__ */ n(
        "textarea",
        {
          ...A,
          ref: g,
          maxLength: M,
          value: a,
          className: N,
          onChange: T,
          onFocus: y,
          onBlur: S,
          style: L
        }
      ),
      /* @__PURE__ */ n("span", { className: i(e.showRequired ? j : null) }),
      /* @__PURE__ */ o("div", { className: q, children: [
        /* @__PURE__ */ n(
          J,
          {
            className: W,
            children: e.infoMessage
          }
        ),
        R
      ] })
    ] })
  ] });
});
v.displayName = "TextArea";
v.defaultProps = {
  shouldEscape: !1
};
export {
  v as default
};
//# sourceMappingURL=TextArea.mjs.map
